/**
 * MO API - Shopify Cart & Account API (native fetch)
 * Migrated from src/alpine/utils/api.js (axios -> fetch)
 */
(function () {
  "use strict";

  window.MO = window.MO || {};

  var HEADERS = {
    "Accept": "*/*",
    "Content-Type": "application/json;",
    "X-Requested-With": "XMLHttpRequest",
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
    "Expires": "0"
  };

  /**
   * Generic GET request
   */
  async function get(url, config) {
    try {
      var opts = { method: "GET", headers: HEADERS };
      if (config && config.headers) {
        opts.headers = Object.assign({}, HEADERS, config.headers);
      }
      var res = await fetch(url, opts);
      if (!res.ok) throw new Error("HTTP " + res.status);
      return res.json();
    } catch (e) {
      console.error("[MO.api] GET " + url + " failed:", e);
    }
  }

  /**
   * Generic POST request (JSON)
   */
  async function post(url, payload) {
    try {
      var res = await fetch(url, {
        method: "POST",
        headers: HEADERS,
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error("HTTP " + res.status);
      return res.json();
    } catch (e) {
      console.error("[MO.api] POST " + url + " failed:", e);
    }
  }

  /**
   * Transform object to FormData
   */
  function toFormData(data) {
    var fd = new FormData();
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        fd.append(key, data[key]);
      }
    }
    return fd;
  }

  /**
   * POST FormData (for account endpoints)
   */
  async function postForm(url, data) {
    try {
      var res = await fetch(url, {
        method: "POST",
        body: toFormData(data)
      });
      return res;
    } catch (e) {
      console.error("[MO.api] POST form " + url + " failed:", e);
    }
  }

  // --- Cart API ---

  async function getCart() {
    var res = await fetch("/cart.js", { headers: HEADERS });
    if (!res.ok) throw new Error("HTTP " + res.status);
    return res.json();
  }

  async function updateCart(updates) {
    var res = await fetch("/cart/update.js", {
      method: "POST",
      headers: HEADERS,
      body: JSON.stringify(updates || {})
    });
    if (!res.ok) throw new Error("HTTP " + res.status);
    return res.json();
  }

  async function addItems(items) {
    var mapped = (items || []).map(function (i) {
      return Object.assign({}, i, {
        properties: Object.assign({}, i.properties, { _p: "default empty property" })
      });
    });
    var res = await fetch("/cart/add.js", {
      method: "POST",
      headers: HEADERS,
      body: JSON.stringify({ items: mapped })
    });
    if (!res.ok) throw new Error("HTTP " + res.status);
    return res.json();
  }

  async function addItem(item) {
    return addItems([
      Object.assign({}, item, {
        properties: Object.assign({}, item.properties, { _p: "default empty property" })
      })
    ]);
  }

  async function changeItem(newItem) {
    var res = await fetch("/cart/change.js", {
      method: "POST",
      headers: HEADERS,
      body: JSON.stringify(newItem)
    });
    if (!res.ok) throw new Error("HTTP " + res.status);
    return res.json();
  }

  function changeQuantity(key, quantity) {
    return changeItem({ id: key, quantity: quantity });
  }

  function removeItem(key) {
    return changeQuantity(key, 0);
  }

  async function getVariant(id) {
    var res = await fetch("/variants/" + id + ".js");
    if (!res.ok) throw new Error("HTTP " + res.status);
    return res.json();
  }

  async function getProduct(handle) {
    var res = await fetch("/products/" + handle + ".js");
    if (!res.ok) throw new Error("HTTP " + res.status);
    return res.json();
  }

  // --- Account API ---

  function reset(params) {
    return postForm("/account/recover", {
      email: params.email,
      form_type: "recover_customer_password",
      utf8: "\u2713"
    });
  }

  function login(params) {
    return postForm("/account/login", {
      "customer[email]": params.email,
      "customer[password]": params.password,
      form_type: "customer_login",
      utf8: "\u2713"
    });
  }

  function register(params) {
    return postForm("/account", {
      "customer[first_name]": params.first_name,
      "customer[last_name]": params.last_name,
      "customer[email]": params.email,
      "customer[password]": params.password,
      form_type: "create_customer",
      utf8: "\u2713"
    });
  }

  function resetPassword(params) {
    return postForm("/account/reset", {
      "customer[password]": params.password,
      "customer[password_confirmation]": params.password_confirmation,
      token: params.token,
      form_type: "reset_customer_password",
      utf8: "\u2713"
    });
  }

  window.MO.api = {
    get: get,
    post: post,
    getCart: getCart,
    updateCart: updateCart,
    addItems: addItems,
    addItem: addItem,
    changeItem: changeItem,
    changeQuantity: changeQuantity,
    removeItem: removeItem,
    getVariant: getVariant,
    getProduct: getProduct,
    reset: reset,
    login: login,
    register: register,
    resetPassword: resetPassword
  };
})();
